import React, { useEffect, useState, useCallback } from "react";
import { Button, Form, Spinner, Alert, Table } from "react-bootstrap";
import useFetchCsrfToken from "../../0. Utilidades/useFetchCsrfToken";

const ExcusaPanel = ({ asistencia, onClose }) => {
  const [maestra, setMaestra] = useState("");
  const [excusaTexto, setExcusaTexto] = useState("");
  const [excusas, setExcusas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const csrfToken = useFetchCsrfToken();

  const fetchExcusas = useCallback(async () => {
    if (!asistencia) return;
    setIsLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/excusas/?asistencia=${asistencia.id}`,
      );
      const data = await res.json();
      setExcusas(data);
    } catch (error) {
      console.error("Error fetching excusas:", error);
    } finally {
      setIsLoading(false);
    }
  }, [asistencia]);

  useEffect(() => {
    fetchExcusas();
  }, [fetchExcusas]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!maestra || !excusaTexto) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_API}api/asistencia/excusas/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({
            asistencia: asistencia.id,
            maestra,
            excusa_texto: excusaTexto,
          }),
          credentials: "include",
        },
      );
      if (res.ok) {
        setExcusaTexto("");
        setMaestra("");
        setShowSuccessAlert(true);
        fetchExcusas();
        setTimeout(() => setShowSuccessAlert(false), 3000);
      }
    } catch (error) {
      console.error("Error posting excusa:", error);
    }
  };

  return (
    <div className="p-3">
      <h6>{asistencia?.curso_nombre.nombre}</h6>
      <h6>
        {asistencia?.curso_nombre.comuna} - {asistencia?.fecha}
      </h6>

      {showSuccessAlert && (
        <Alert variant="success">Excusa enviada correctamente.</Alert>
      )}

      <Form onSubmit={handleSubmit} className="mb-4">
        <Form.Group className="asistencia-curso-excusa-maestras">
          <Form.Label>Selecciona una Maestra</Form.Label>
          <Form.Select
            value={maestra}
            onChange={(e) => setMaestra(e.target.value)}
            required
          >
            <option value="">-- Selecciona --</option>
            {asistencia?.curso_elegidas?.map((m) => (
              <option key={m.rut} value={m.rut}>
                {m.nombre} ({m.rut})
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="asistencia-curso-excusa">
          <Form.Label>Escribir Excusa</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={excusaTexto}
            onChange={(e) => setExcusaTexto(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" style={{ fontSize: "12px" }}>
          Enviar Excusa
        </Button>
      </Form>

      {isLoading ? (
        <div className="d-flex justify-content-center p-3">
          <Spinner />
        </div>
      ) : (
        <Table striped bordered size="sm">
          <thead>
            <tr>
              <th>Maestra</th>
              <th>Excusa</th>
            </tr>
          </thead>
          <tbody>
            {excusas.map((e) => (
              <tr key={e.id}>
                <td>
                  {e.maestra_nombre.nombre} ({e.maestra_nombre.rut})
                </td>
                <td>{e.excusa_texto}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default ExcusaPanel;
